import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Rent } from '@model/rent';
import { PAYMENT } from '@theme/utils/functions';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RentAddComponent } from '@locataire/rent/rent-add/rent-add.component';
import { RentSoldeComponent } from '@locataire/rent/rent-solde/rent-solde.component';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { RentService } from '@service/rent/rent.service';
import { RentShowComponent } from '../rent-show/rent-show.component';
import {EmitterService} from '@service/emitter/emitter.service';
import { Globals } from '@theme/utils/globals';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import {InvoiceService} from "@service/invoice/invoice.service";

@Component({
  selector: 'app-rent-list',
  templateUrl: './rent-list.component.html',
  styleUrls: ['./rent-list.component.scss']
})
export class RentListComponent implements OnInit {
  @Input() rents: Rent[]
  @Input() locataire: boolean = true
  checked: boolean = false;
  dtOptions: any = {};
  etat: boolean = false
  global = {country: Globals.country, device: Globals.device}
  userSession = Globals.user
  rent = PAYMENT
  total = 0;
  paye = 0;
  impaye = 0;
  solde = 0;
  form: FormGroup;

  constructor(
    private formBuild: FormBuilder,
    private modalService: NgbModal,
    private rentService: RentService,
    private emitter: EmitterService,
    private invoiceService: InvoiceService
  ) {
  }

  ngOnInit(){
    this.etat = this.rents ? true : false;
    if(this.etat){
      this.rents.forEach(item => {
        this.total += item?.invoice.montant
        this.paye += item?.invoice.paye
        this.impaye += item?.invoice.impaye
        this.solde += item?.invoice.solde
        return
      })
      this.table();
    }
    this.dtOptions = Globals.dataTable;
    this.emitter.event.subscribe((data) => {
      if (data.action === 'RENT_ADD') {
        this.appendToList(data.payload);
      }
    });
  }

  table(){
    this.form = this.formBuild.group({
      lignes: this.formBuild.array(this.item())
    });
  }
  checkEtat(item){
    const form = {
      uuid: item?.uuid
    }
    this.rentService.checkEtat(form).subscribe(res => {
      if (res?.status === 'success') {
        this.appendToList(res.data);
      }
    })
  }
  item(): FormGroup[] {
    var arr: any[] = []
    if(this.rents && this.rents.length > 0){
      this.rents.forEach((item) =>{
        let etat = item?.type === 'LOYER' && item?.invoice?.etat === 'SOLDE' && item?.contract?.etat === 'ACTIF' ? false : true;
        arr.push(
          this.formBuild.group({
            uuid: [null],
            checked: [{value: false, disabled: etat }],
          })
        )
      })
    }
    console
    return arr;
  }
  onSelectAll($event) {
    if($event.target.checked === true && this.rents && this.rents.length > 0){
      this.checked = true;
      this.rents.forEach((item, index) =>{
        if (item?.type === 'LOYER' && item?.invoice?.etat === 'SOLDE' && item?.contract?.etat === 'ACTIF') {
          this.lignes.at(index).get('uuid').setValue(item?.uuid);
          this.lignes.at(index).get('checked').setValue(true);
        }
      })
    } else {
      this.checked = false;
      this.rents.forEach((item, index) =>{
        if (item?.type === 'LOYER' && item?.invoice?.etat === 'SOLDE' && item?.contract?.etat === 'ACTIF') {
          this.lignes.at(index).get('uuid').setValue(null);
          this.lignes.at(index).get('checked').setValue(false);
        }
      })
    }
  }
  onSelect(index, row) {
    if (this.lignes.controls[index].get('checked').value === true) {
      this.checked = true;
      this.lignes.controls[index].get('uuid').setValue(row?.uuid)
    }
  }
  appendToList(rent): void {
    this.rents.unshift(rent);
  }
  addRent() {
    this.modalService.dismissAll()
    this.rentService.edit = false
    this.modal(RentAddComponent, 'modal-basic-title', 'xl', true, 'static')
  }
  editMontant(row) {
    this.rentService.setRent(row)
    this.rentService.edit = true
    this.rentService.type = row.type
    this.modal(RentSoldeComponent, 'modal-basic-title', 'lg', true, 'static')
  }
  showRent(row) {
    this.rentService.setRent(row)
    this.modal(RentShowComponent, 'modal-basic-title', 'lg', true, 'static')
  }
  printerRent(row): void {
    this.rentService.getPrinter('SHOW', this.userSession?.agencyKey, this.userSession?.uuid, row?.uuid);
  }
  printerAssocie() {
    if (this.form.valid) {
      var data = this.form.getRawValue()
      this.rentService.getPrinterAssocie(data).subscribe(
        res => {
          if (res?.status === 'success') {
            console.log(res)
            // let blob = new Blob([res.data], {
            //   type: res.headers.get('content-type')
            // })
            // let url = URL.createObjectURL(blob);
            // window.open(url, '_blank')
          }
        }, error => {
        });
    }
  }
  printerProforma(row) {
    this.rentService.getPrinterProforma('SHOW', this.userSession?.agencyKey, this.userSession?.uuid, row?.uuid);
  }
  delete(item) {
    Swal.fire({
      title: '',
      text: 'Voulez-vous vraiment supprimer cet enrégistrement ?',
      showCancelButton: true,
      showCloseButton: true,
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Supprimer <i class="feather icon-trash"></i>',
      confirmButtonColor: '#d33',
      timer: 2500,
      reverseButtons: true
    }).then((willDelete) => {
      if (willDelete.dismiss) {
      } else {
        this.rentService.getDelete(item?.uuid).subscribe(res => {
          if (res?.status === 'success') {
            const index = this.rents.findIndex(x => x.id === item.id);
            if (index !== -1) {
              this.rents.splice(index, 1);
            }
            Swal.fire('', res?.message, 'success');
          }
        })
      }
    });
  }

  normalize(invoice) {
    Swal.fire({
      title: '',
      text: 'Voulez-vous vraiment normaliser cette facture ?',
      showCancelButton: true,
      showCloseButton: true,
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Normaliser <i class="fas fa-receipt"></i>',
      confirmButtonColor: '#054200',
      timer: 2500,
      reverseButtons: true
    }).then((action) => {
      if (action.dismiss) {
      } else {
        this.invoiceService.normalize(this.userSession.uuid, invoice?.uuid).subscribe(res => {
          if (res?.status === 'success') {
            Swal.fire('', res?.message, 'success');
          }
        })
      }
    });
  }

  printerStandardizedInvoice(item) {
    console.log(item)
    this.invoiceService.getPrinterStandardizedInvoice(this.userSession?.agencyKey, this.userSession?.uuid, item.standardized?.uuid);
  }

  standardize() {
    Swal.fire({
      title: '',
      text: 'Voulez-vous vraiment normaliser ces factures ?',
      showCancelButton: true,
      showCloseButton: true,
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Normaliser <i class="fas fa-receipt"></i>',
      confirmButtonColor: '#054200',
      timer: 2500,
      reverseButtons: true
    }).then((action) => {
      if (action.dismiss) {
      } else {

        let uuids: string[] = [];

        this.lignes.controls.forEach((ligne: any) => { uuids.push(ligne.uuid) });

        this.invoiceService.standardize(this.userSession.uuid, uuids).subscribe(res => {
          if (res?.status === 'success') {
            Swal.fire('', res?.message, 'success');
          }
        })
      }
    });
  }

  modal(component, type, size, center, backdrop) {
    this.modalService.open(component, {
      ariaLabelledBy: type,
      size: size,
      centered: center,
      backdrop: backdrop
    }).result.then((result) => {

    }, (reason) => {

    });
  }
  get lignes() { return this.form.get('lignes') as FormArray; }

}
